module.exports = __webpack_public_path__ + "static/media/exclamation_red.76109be6.svg";